import * as constants from './constants'
import {getInfoList,delInfoOne,InfoImport} from '../../../api/informationPage'
import {message} from 'antd'
import { BasicList as keys } from '../../../utils/config'
//获取列表内容
const loadlists = (result) => ({
    type: constants.LOADLISTS,
    list: result.list
})

//获取列表内容总数
const loadtotals = (result) => ({
    type: constants.LOADTOTALS,
    total: result.count
})
//设置current
const currents = (current) => ({
    type: constants.CURRENTS,
    current: current
})
//重置current
const initcurrents = () => ({
    type: constants.INITCURRENTS,
    current: 1
})
//获取搜索框内容
const values = (value) => ({
    type: constants.VALUES,
    values: value
})
const removelist = () => ({
    type: constants.REMOVEPUPOPOK,
    show: false,
})
const changeadjunctionvisible = (visible) => ({
    type: constants.CHANGE_ADJUNCTION_VISIBLE,
    visible
})

// 重置列表内容
const requestList = async (key,value = '',current= 1,id)=>{
    const info = {
        pageSize:10,
        currentPage:current,
        informationTypeId:keys[key] || id,
    }
    if(value){
        info.name = value
    }
    const res  = await getInfoList(info)
    const result = res.data || []
    return result
}
const handleRes = (datas) => {
    datas.list.forEach((element,index,arr) => {
        const handleRoute = []
        if( element.route ){
            const tempArr = JSON.parse(String(element.route))
            
            for(let item of tempArr) {
                const tempObj = {}
                tempObj.longitude = item[0]
                tempObj.latitude = item[1]
                handleRoute.push(tempObj)
            }                
        } else{
            const defaultLag = {
                 longitude: 120.63262,
                 latitude: 27.97782
            }
            const defaultLag2 = {
                longitude: 120.73081,
                latitude: 28.140817
            }
            handleRoute[0] = defaultLag
            handleRoute[1] = defaultLag2
        }
        arr[index].routeStr = element.route || ''
        arr[index].route = handleRoute
    });
    return datas
}
// 批量导入
export const batchInfo = (data,key,values,current)=>{
    return async dispatch =>{
        await InfoImport(data)
        const result =  await requestList(key,values,current)
        dispatch(loadlists(result.data))
        dispatch(loadtotals(result))
        dispatch(currents(current))
        dispatch(onBatchHide())
        message.success('批量导入成功')
    }
}
//获取表格内容
export const loadlist = (key) => {
    return async (dispatch) => {
        const data = {
            pageSize:10,
            currentPage:1,
            informationTypeId:keys[key],
          }
        const res  = await getInfoList(data)
        // 处理坐标点格式
        
        

        
        const datas = handleRes(res.data.data)
        const result = datas || []
        dispatch(loadlists(result))
        dispatch(loadtotals(res.data || []))
    }
}
//语音弹窗显示
export const soureshow = () => ({
    type: constants.SOURCESHOW,
    sourcevisible: true
})
//语音弹窗隐藏
export const sourcehide = () => ({
    type: constants.SOURCEHIDE,
    sourcevisible: false
})
//图片展示弹窗显示
export const carouselshow = () => ({
    type: constants.CAROUSEL_SHOW,
    carouselvisible: true
})
//图片展示弹窗隐藏
export const carouselhide = () => ({
    type: constants.CAROUSEL_HIDE,
    carouselvisible: false
})
//二维码展示弹窗显示
export const onvisible = () => ({
    type: constants.ONVISIBLE,
    visible: true
})
//二维码展示弹窗隐藏
export const qrCodevisible = () => ({
    type: constants.QRCODEVISIBLE,
    visible: false
})
// 批量处理显示
export const onBatchShow = () => ({
    type: constants.ONBATCHSHOW,
    visible: true
})
// 批量处理隐藏
export const onBatchHide = () => ({
    type: constants.ONBATCHHIDE,
    visible: false
})
export const qrCodecontent = (record) => ({
    type: constants.QRCODECONTENT,
    content: record
})
export const removepupopok = (informationId,informationTypeId,current,values) => {
    return async (dispatch) => {
        const data = {
            informationId,
            informationTypeId
        }
        await delInfoOne(data)
        const result =  await requestList(null,values,current,informationTypeId)
        dispatch(loadlists(result.data))
        dispatch(loadtotals(result))
        dispatch(currents(current))
        message.success('删除成功')
    }
}
export const uploadingshow = () => ({
    type: constants.UPLOADING_SHOW,
    uploadvisible: true
})
export const uploadinghide = () => ({
    type: constants.UPLOADING_HIDE,
    uploadvisible: false
})
// 分页
export const paginationchange = (current, key, values) => {
    return async (dispatch) => {
            const result =  await requestList(key,values,current)
            dispatch(loadlists(result.data))
            dispatch(loadtotals(result))
            dispatch(currents(current))
    }
}
export const inputsearch = (value, key) => {
    return async (dispatch) => {
        const result =  await requestList(key,value)
        dispatch(loadlists(result.data))
        dispatch(loadtotals(result))
        dispatch(values(value))
        dispatch(initcurrents())
    }
}
export const searchchange = (value, key) => {
    return async (dispatch) => {
        if (value == '') {
            const result =  await requestList(key)
            dispatch(loadlists(result.data))
            dispatch(loadtotals(result))
            dispatch(initcurrents())
            dispatch(values())
        }
    }
}
export const addandhide = (key) => {
    return async (dispatch) => {
        dispatch(uploadinghide())
    }
}
export const amendshow = () => ({
    type: constants.AMEND_SHOW,
    amendvisible: true
})
export const amendhide = () => ({
    type: constants.AMEND_HIDE,
    amendvisible: false
})
export const amendandhide = (key, current) => {
    return async (dispatch) => {
        dispatch(amendhide())
    }
}
export const maintainshow = () => ({
    type: constants.MAINTAIN_SHOW,
    maintainvisible: true
})
export const maintainhide = () => ({
    type: constants.MAINTAIN_HIDE,
    maintainvisible: false
})
export const maintainsuccess = (key, current) => {
    return async (dispatch) => {
        const result =  await requestList(key,null,current)
        const res = handleRes(result.data)
        dispatch(loadlists(res))
        dispatch(loadtotals(result))
        dispatch(uploadinghide())
        dispatch(amendandhide())
        dispatch(currents(current))
    }
}
export const setadjunctionvisible = (visible) => {
    return (dispatch) => {
        dispatch(changeadjunctionvisible(visible))
    }
}